import React from 'react';

export const HomeIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 24, width = 24 }) => (
  <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 5L27 14V27H20V20C20 18.9 19.1 18 18 18H14C12.9 18 12 18.9 12 20V27H5V14L16 5ZM16 4C15.8 4 15.6 4.1 15.4 4.2L4.4 13.2C4.1 13.4 4 13.7 4 14V27C4 27.6 4.4 28 5 28H12C12.6 28 13 27.6 13 27V20C13 19.4 13.4 19 14 19H18C18.6 19 19 19.4 19 20V27C19 27.6 19.4 28 20 28H27C27.6 28 28 27.6 28 27V14C28 13.7 27.9 13.4 27.6 13.2L16.6 4.2C16.4 4.1 16.2 4 16 4Z"
      fill="black"
    />
  </svg>
);
